import {
  SET_ACADEMY_COURSE_PRODUCTS,
} from '../actions/types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_ACADEMY_COURSE_PRODUCTS:
      return [ ...action.payload ];
    default:
      return state;
  }
};
